import { components } from 'src/infrastructure/rest-api/generated';
import { useChainFurnitureZoneQuery } from '../queries/useChainFurnitureZoneQuery';

export type ChainFurnitureZoneRow = components['schemas']['ChainFurnitureZoneModel'];

export const useChainFurnitureZoneRows = () => {
    const { data, loading, error } = useChainFurnitureZoneQuery();

    return { data: data ?? [], loading, error };
};
